import { useEffect, useState } from 'react';
import { useApi } from '../api/useApi';
import { mediaUrl } from '../api/client';
import { WHATSAPP_URL } from '../data/contact';

const LINKS = [
  { href: '#home', label: 'Inicio' },
  { href: '#about', label: 'Nosotros' },
  { href: '#team', label: 'Equipo' },
  { href: '#clients', label: 'Clientes' },
  { href: '#blog', label: 'Blog' },
];

export default function Nav() {
  const { data: settings, loading } = useApi('/settings', 'settings');
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navClassName = [
    'site-nav',
    scrolled ? 'site-nav--scrolled' : '',
    open ? 'site-nav--menu-open' : '',
  ]
    .filter(Boolean)
    .join(' ');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const logoUrl = settings?.logo?.image_url;

  return (
    <header className={navClassName}>
      <div className="site-nav__inner container">
        <a href="#home" className="site-nav__brand" onClick={() => setOpen(false)}>
          {loading ? (
            <span className="site-nav__brand-text">Sustento Jurídico</span>
          ) : logoUrl ? (
            <img src={mediaUrl(logoUrl)} alt="Sustento Jurídico" className="site-nav__logo" />
          ) : (
            <span className="site-nav__brand-text">Sustento Jurídico</span>
          )}
        </a>

        <nav id="site-nav-menu" className={`site-nav__menu ${open ? 'site-nav__menu--open' : ''}`}>
          <ul className="site-nav__links">
            {LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={() => setOpen(false)}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href={WHATSAPP_URL}
            className="site-nav__cta"
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
          >
            Contáctanos
          </a>
        </nav>

        <button
          type="button"
          className="site-nav__toggle"
          aria-expanded={open}
          aria-controls="site-nav-menu"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="site-nav__toggle-line" />
          <span className="site-nav__toggle-line" />
        </button>
      </div>
    </header>
  );
}
